// https://vuex.vuejs.org/ja/guide/mutations.html

import types from './mutationTypes';
import { Logger } from 'aws-amplify';

const logger = new Logger('mutations');
const Mutations = {
  /**
   * 画面のタイトル設定
   * @param state
   * @param payload
   */
  [types.SET_PAGE_TITLE]: (state, payload) => {
    logger.info(types.SET_PAGE_TITLE, payload);
    state.pageTitle = payload;
  },

  /**
   * 最初にアクセスされたROUTE設定
   * @param state
   * @param payload
   */
  [types.SET_INITIAL_ROUTE]: (state, payload) => {
    // 未設定の場合のみ設定する
    if (!state.initialRoute) {
      logger.info(types.SET_INITIAL_ROUTE, payload);
      state.initialRoute = payload;

      // local storageにも保存する
      localStorage.setItem(types.SET_INITIAL_ROUTE, JSON.stringify(payload));
    }
  },

  /**
   * 最初にアクセスされたROUTE設定を復元する
   * @param state
   */
  [types.RESTORE_INITIAL_ROUTE]: (state) => {
    // local storageから取得する
    const result = localStorage.getItem(types.SET_INITIAL_ROUTE);
    if (result) {
      state.initialRoute = JSON.parse(result);
      localStorage.removeItem(types.SET_INITIAL_ROUTE);
    }
    logger.info(types.RESTORE_INITIAL_ROUTE, result);
  },

  /**
   * 認証情報の設定
   * @param state
   * @param payload
   */
  [types.SET_AUTH]: (state, payload) => {
    logger.info(types.SET_AUTH, payload);
    state.auth = payload.auth;
  },

  /**
   * おしらせ1件設定
   * @param state
   * @param payload
   */
  [types.SET_NOTIFICATION]: (state, payload) => {
    logger.info(types.SET_NOTIFICATION, payload);

    // IDで検索し一覧に存在していたら上書き
    // なければ追加する
    const index = state.notifications.findIndex(x => x.id === payload.id);
    if (index >= 0) {
      // Vueに変更を伝えるため。=の代入ではレイアウト更新などが発生しない
      Object.assign(
          state.notifications[index], convertNotificationToState(payload));
    } else {
      state.notifications.unshift(convertNotificationToState(payload));
    }
  },

  /**
   * おしらせ一覧の設定
   * @param state
   * @param payload
   */
  [types.SET_NOTIFICATIONS]: (state, payload) => {
    logger.info(types.SET_NOTIFICATIONS, payload);
    // stateの形式に変換して設定する
    state.notifications = payload.map(x => convertNotificationToState(x));
  },

  /**
   *
   * @param state
   * @param payload
   */
  [types.SET_FILES]: (state, payload) => {
    logger.info(types.SET_FILES, payload);

    // カテゴリーごと=>ファイル名でソートしている

    switch (payload.category) {
      case 'manual':
        state.files.manual = payload.results.map(
            x => convertFileToState(x)).sort((a, b) => {
          if (a.category !== b.category) {
            return a.category > b.category ? 1 : -1;
          }

          return a.filename > b.filename ? 1 : -1;
        });
        break;
      case 'ui_ux':
        state.files.uiUx = payload.results.map(
            x => convertFileToState(x)).sort((a, b) => {
          if (a.category !== b.category) {
            return a.category > b.category ? 1 : -1;
          }

          return a.filename > b.filename ? 1 : -1;
        });
        break;
    }
  },

  /**
   * 制度・福利厚生1件設定
   * @param state
   * @param payload
   */
  [types.SET_WELFARE]: (state, payload) => {
    logger.info(types.SET_WELFARE, payload);

    // IDで検索し一覧に存在していたら上書き
    // なければ追加する
    const index = state.welfares.findIndex(x => x.id === payload.id);
    if (index >= 0) {
      // Vueに変更を伝えるため。=の代入ではレイアウト更新などが発生しない
      Object.assign(
          state.welfares[index], convertWelfareToState(payload));
    } else {
      state.welfares.unshift(convertWelfareToState(payload));
    }
  },

  /**
   * 制度・福利厚生一覧の設定
   * @param state
   * @param payload
   */
  [types.SET_WELFARES]: (state, payload) => {
    logger.info(types.SET_WELFARES, payload);
    // stateの形式に変換して設定する
    state.welfares = payload.map(x => convertWelfareToState(x));
  },
};
export default Mutations;

/**
 * payloadのおしらせをstateの形式にする
 * @param payload
 */
function convertNotificationToState(payload) {
  try {
    const attributes = JSON.parse(payload.attributes);
    return {
      id: payload.id,
      contributedAt: payload.contributedAt.substr(0, 10),
      updatedAt: payload.updatedAt.substr(0, 10),
      body: attributes.body,
      contributor: attributes.contributor || '',
      title: attributes.title || '',
      category: attributes.category || '',
    };
  } catch (e) {
    logger.error('convertNotificationToState', e);
  }
}

/**
 * マニュアルのファイル情報をstateの形式に変換する
 * @param payload
 * @returns {{filename, contributor: (string|*), downloadUrl: (default.methods.downloadUrl|string|*), id, category, url, updatedAt: (string|*)}}
 */
function convertFileToState(payload) {
  try {
    const attributes = JSON.parse(payload.attributes);
    return {
      id: payload.id,
      filename: attributes.filename,
      category: attributes.category,
      url: attributes.url,
      downloadUrl: attributes.downloadUrl,
      contributor: attributes.contributor,
      updatedAt: attributes.updatedAt,
      enableDownload: attributes.enableDownload || false,
    };
  } catch (e) {
    logger.error('convertManualFileToState', e);
  }
}

/**
 * payloadのおしらせをstateの形式にする
 * @param payload
 */
function convertWelfareToState(payload) {
  try {
    const attributes = JSON.parse(payload.attributes);
    return {
      id: payload.id,
      contributedAt: payload.contributedAt.substr(0, 10),
      updatedAt: payload.updatedAt.substr(0, 10),
      body: attributes.body,
      contributor: attributes.contributor || '',
      title: attributes.title || '',
      category: attributes.category || '',
    };
  } catch (e) {
    logger.error('convertWelfareToState', e);
  }
}